import type { SummarySort } from '~domains/commerce/dashboard/entities/summary';

import type { DataTableSorting } from '~shared/ui/data-table';

import { ColumnId } from './columns';

const orderMapping = {
  asc: 'ASC',
  desc: 'DESC',
} as const;

type ColumnsWithSort = 'loansAmount' | 'loansCount' | 'salesAmount';

const columnToOrderByMapping: Record<ColumnsWithSort, SummarySort['key']> = {
  [ColumnId.LOANS_AMOUNT]: 'loansAmount',
  [ColumnId.LOANS_COUNT]: 'loansCount',
  [ColumnId.SALES_AMOUNT]: 'salesAmount',
} as const;

export function sortToParams({ id, direction }: DataTableSorting): SummarySort {
  return {
    key: columnToOrderByMapping[id as ColumnsWithSort],
    order: orderMapping[direction],
  };
}
